var map = {
	"./asset-hyperlink.json": 3502,
	"./blockquote.json": 7784,
	"./document.json": 4634,
	"./embedded-asset-block.json": 6188,
	"./embedded-entry-block.json": 4160,
	"./embedded-entry-inline.json": 3290,
	"./embedded-resource-block.json": 7904,
	"./embedded-resource-inline.json": 7242,
	"./entry-hyperlink.json": 830,
	"./heading-1.json": 2713,
	"./heading-2.json": 3036,
	"./heading-3.json": 8399,
	"./heading-4.json": 1634,
	"./heading-5.json": 8317,
	"./heading-6.json": 2800,
	"./hr.json": 8381,
	"./hyperlink.json": 1203,
	"./list-item.json": 4421,
	"./ordered-list.json": 3867,
	"./paragraph.json": 6311,
	"./resource-hyperlink.json": 7272,
	"./table-cell.json": 5156,
	"./table-header-cell.json": 8132,
	"./table-row.json": 3388,
	"./table.json": 5825,
	"./text.json": 4084,
	"./unordered-list.json": 1464
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5152;